import { HEADER_HEIGHT } from 'config/ui'

export default {
  toolbar: {
    minHeight: HEADER_HEIGHT,
  },
}
